import * as React from "react";
const SvgDeleteDangerIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.4004 5.43164H2.50027", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.40729, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.67388 5.43164L4.15635 13.6337C4.21469 14.6255 5.036 15.3999 6.02951 15.3999H11.8729C12.8664 15.3999 13.6877 14.6255 13.746 13.6337L14.2285 5.43164", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.40729, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.4697 5.43184V4.84549C12.4697 3.55011 11.4196 2.5 10.1242 2.5H7.77879C6.48341 2.5 5.4333 3.55011 5.4333 4.84549V5.43184", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.40729, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.71 8.36328V11.8815", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.40729, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.19141 8.36426V11.8825", stroke: "#FF3B3B", style: {
  stroke: "#FF3B3B",
  stroke: "color(display-p3 1.0000 0.2314 0.2314)",
  strokeOpacity: 1
}, strokeWidth: 1.40729, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDeleteDangerIcon;
